const isFalse = (boolean) => {
    return !boolean;
};
const isTruthy = (value) => {
    return Boolean(value);
};
const isFalsy = (value) => {
    return !value;
};
export { isFalse, isTruthy, isFalsy };
//# sourceMappingURL=boolean.js.map